import { Fragment, FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import useHasInvertedColors from '@hooks/useHasInvertedColors'
import Name from '@widgets/Author/Common/AuthorsWithoutImages/Name'
import { getSeparatorChar } from '@widgets/Author/Common/AuthorsWithoutImages/utils'
import BrandLogo from '@widgets/Author/Common/BrandLogo'
import ClickableContainer from '@widgets/Author/Common/ClickableContainer'
import { AuthorAPIProps, AuthorProps } from '@widgets/Author/types'
import { isLink } from '@widgets/Author/utils'

type AuthorWithoutImages = Pick<AuthorProps, 'name' | 'link'>

type AuthorsWithoutImagesProps = Pick<
  AuthorAPIProps,
  'contentOriginImage' | 'contentOrigin' | 'contentOriginImageDark'
> & {
  children: AuthorWithoutImages[]
}

const AuthorsWrapper = styled.div``

const SeparatorChar = styled.span<{ hasInvertedColors: boolean }>`
  ${({
    theme: {
      colors: { textDefault, staticWhite },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadsCSS },
        },
      },
    },
    hasInvertedColors,
  }) => css`
    ${small1SubheadsCSS};
    color: ${hasInvertedColors ? staticWhite : textDefault};
  `}
`

const StyledAuthorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const AuthorsWithoutImages: FunctionComponent<AuthorsWithoutImagesProps> = ({
  children,
  contentOriginImage,
  contentOrigin,
  contentOriginImageDark,
}) => {
  const hasInvertedColors = useHasInvertedColors()
  const lastIndex = children.length - 1

  return (
    <StyledAuthorsWrapper>
      <AuthorsWrapper>
        {children.map((author, index) => {
          const link = author.link
          const isClickable = isLink(link)
          return (
            <Fragment key={author.name}>
              <ClickableContainer link={link}>
                <Name
                  isClickable={isClickable}
                  hasInvertedColors={hasInvertedColors}
                >
                  {author.name}
                  {/*This space is needed for so that the authors correctly wrap to another line*/}
                </Name>
              </ClickableContainer>
              <SeparatorChar
                hasInvertedColors={hasInvertedColors}
              >{`${getSeparatorChar(index, lastIndex)} `}</SeparatorChar>
            </Fragment>
          )
        })}
      </AuthorsWrapper>
      {!!contentOriginImage && (
        <BrandLogo
          contentOrigin={contentOrigin}
          contentOriginImageDark={contentOriginImageDark}
          {...contentOriginImage}
        />
      )}
    </StyledAuthorsWrapper>
  )
}

export default AuthorsWithoutImages
